class QuickviewVariantSelect extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.querySelectorAll(".option-item").forEach((option) => {
      option.addEventListener("click", this.onVariantChange.bind(this))
    })
  }

  onVariantChange(evt) {
    this.target = evt.target
    var select = this.target.closest(".variation_switcher_item")

    select?.querySelectorAll('.option-item').forEach((option) => {
      option.classList.remove('selected')
    })

    this.target.closest(".option-item").classList.add('selected')

    select.querySelector(".selected-value").innerHTML = this.target.closest(".option-item").getAttribute("data-value")
    
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }


  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {

      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );      
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
    if (document.getElementById("easy_product_gallery_slider").classList.contains("slick-slider")) {
        var num = parent.getAttribute("data-slick-index");
        $("#easy_product_gallery_slider").slick('slickGoTo', num);
    }
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {

    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;
        var meta_id = `meta-${this.dataset.section}`;
        var meta_destination = document.getElementById(meta_id);
        var meta_source = html.getElementById(meta_id);
        if (meta_source && meta_destination) meta_destination.innerHTML = meta_source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');

    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
    var meta_id = `meta-${this.dataset.section}`;
    var meta_destination = document.getElementById(meta_id);
    var available = meta_destination.querySelector(".availability span[data-available]");
    available.innerHTML = window.variantStrings.unavailable;
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]')?.textContent);
    return this.variantData;
  }
}

customElements.define('quickview-variant-selects', QuickviewVariantSelect);

class QuickviewVariantRadios extends QuickviewVariantSelect {
  constructor() {
    super();
  }

  updateOptions() {
    const current_fieldset = Array.from(this.querySelectorAll('.variation_switcher_item'));
    this.options = current_fieldset.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('.option-item'))?.find((radio) => radio.classList.contains('selected')).getAttribute("data-value");
    });
    var all_fieldsets = Array.from(document.querySelectorAll('.variation_switcher_item'));
    var other_fieldset = all_fieldsets.filter(x => !current_fieldset.includes(x))
    other_fieldset.map((fieldset) => {
      Array.from(fieldset.querySelectorAll('.option-item')).find((radio) => {
        if (this.options.includes(radio.getAttribute('data-value'))) {
          if (!radio.classList.contains("selected")) {
            radio.classList.add('selected')
            var event = new Event('click');
            radio.dispatchEvent(event)
          }
        } else {
          radio.classList.remove('selected')
        }
      });
    });
  }
}
customElements.define('quickview-variant-radios', QuickviewVariantRadios);
